module.exports = __webpack_public_path__ + "static/media/tiempos_de_juventud.07d5dfff.md";